import React, { PureComponent } from 'react'
import { any, shape, object, string } from 'prop-types'
import { Icon, Text } from 'components'

import './ImageAndText.css'

export class ImageAndText extends PureComponent {
    static propTypes = {
        image: shape({
            src: any.isRequired,
            style: object
        }),
        text: string.isRequired,
        className: string
    }

    render() {
        const { image, icon, text, className, ...otherProps } = this.props
        return (
            <div className={['ImageAndText', className]} {...otherProps}>
                {icon && <Icon name={icon.name} color="Primary" style={icon.style} />}
                {image && <img src={image.src} style={image.style} />}
                <Text dangerouslySetInnerHTML={{ __html: text }} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/ImageAndText/ImageAndText.js